module.exports = __webpack_public_path__ + "static/media/ic_rec_start.8c939fc2.svg";